export default "__VITE_ASSET__ce643e98__"